import React from 'react';
import { connect } from 'react-redux';

import styled from 'styled-components';
import { media } from 'helpers/MediaHelper';

const StyledMain = styled.main`
  background-color: #fafafc;
  margin-top: 53px;
  height: 100vh;
  overflow: scroll;
  ${media.mobile`
    margin-top: 0;
  `};
`;
const LeadManaging = ({ leadManagingLink }) => {
  return (
    <StyledMain>
      <iframe
        title="lead-managing"
        type="text/html"
        frameBorder="0"
        src={leadManagingLink}
        style={{
          width: '100%',
          height: '100%',
        }}
      />
    </StyledMain>
  );
};

const mapStateToProps = state => ({
  leadManagingLink: state.userTypes.leadManagingLink,
});

export default connect(mapStateToProps)(LeadManaging);
